import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VideoPlayerDialog } from 'src/pages/home/home.component';

@Component({
  selector: 'app-success-stories',
  templateUrl: './success-stories.component.html',
  styleUrls: ['./success-stories.component.scss']
})
export class SuccessStoriesComponent  implements OnInit{

  @Input('slider1') slider1:any[]=[];

  @Input('slider2') slider2:any[]=[];

  @Input('pageType') pageType:any;


  constructor(public dialog: MatDialog){}

  ngOnInit(): void {
    
  }

  playVideo(obj: any) {
    const dialogref = this.dialog.open(VideoPlayerDialog, {
      width: '800px',
      data: { video: 'https://www.youtube.com/embed/' + obj.video + '?rel=0', type: 'toppers' },
      panelClass: ['video-dialog', 'video-dilogue2']
    })
    dialogref.afterClosed().subscribe(result => {

    })
  }


}
